/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=82f22a4c&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=82f22a4c&lang=css"
import "./App.vue?vue&type=style&index=1&id=82f22a4c&scoped=true&lang=css"

import exportComponent from "D:\\object\\vue\\file-viewer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82f22a4c"]])

export default __exports__